var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.89,22.55l-1.78.9L20.88,23l-1.64-3.29L14.72,17H9.28L4.76,19.71,3.12,23l-.23.45-1.78-.9,2.13-4.26L8.72,15h6.56l5.48,3.29ZM6.49,10.86,6,10V4l.49-.86,5-3h1l5,3L18,4v6l-.49.86-5,3h-1ZM8,9.43l4,2.4,4-2.4V4.57l-4-2.4L8,4.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/1787897133/media/icon-profile.1c6ad55d7fddd575e86335d4efa60d84.svg";
export { ForwardRef as ReactComponent };